<template>
  <div class="help-container">
    <el-tooltip content="反馈" placement="left" effect="light">
      <div @click.stop="toFeedback" class="item-help">
        <SvgIcon name="feedback" style="font-size: 40px"></SvgIcon>
      </div>
    </el-tooltip>
    <!-- 返回顶部 -->
    <el-tooltip content="返回顶部" placement="left" effect="light">
      <transition name="el-fade-in-linear">
        <div v-if="visible" @click.stop="scrollToTop" class="item-help">
          <SvgIcon name="backtop"></SvgIcon>
        </div>
      </transition>
    </el-tooltip>
  </div>
</template>
<script setup lang="ts">
const toFeedback = () => {
  //   window.location.href = 'https://txc.qq.com/products/659177';
  window.open('https://txc.qq.com/products/659177', '_blank');
};

const el = shallowRef<HTMLElement>();
const container = shallowRef<Document | HTMLElement>();
const visible = ref(false);
const target = ref<string>('.app-scrollbar');

const scrollToTop = (_event: MouseEvent) => {
  el.value?.scrollTo({ top: 0, behavior: 'smooth' });
};

const handleScroll = () => {
  if (el.value) visible.value = el.value.scrollTop >= 200;
};

onMounted(() => {
  el.value = document.querySelector<HTMLElement>(target.value) ?? undefined;
  container.value = el.value;
  container.value!.addEventListener('scroll', handleScroll);
  handleScroll();
});

onBeforeUnmount(() => {
  container.value!.removeEventListener('scroll', handleScroll);
});
</script>

<style scoped lang="scss">
.help-container {
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  gap: 20px;
  position: fixed;
  z-index: 5;
  right: 40px;
  bottom: 40px;
  width: 40px;
  height: 200px;

  .item-help {
    --el-backtop-bg-color: var(--el-bg-color-overlay);
    --el-backtop-text-color: var(--el-color-primary);
    --el-backtop-hover-bg-color: var(--el-border-color-extra-light);
    align-items: center;
    background-color: var(--el-backtop-bg-color);
    border-radius: 50%;
    box-shadow: var(--el-box-shadow-lighter);
    color: var(--primary-color);
    cursor: pointer;
    display: flex;
    font-size: 20px;
    width: 40px;
    height: 40px;
    justify-content: center;
  }
}
</style>
